var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Info"},[_c('InfoForm',{ref:"infoForm"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }